export default __webpack_public_path__ + "static/pierce-98cb9c4123acac843ce8d1592a8cddcd.png";